document.addEventListener('DOMContentLoaded', () => {
  const handleScrollShadows = () => {
    const container = document.querySelector('.mini-compare-grid--multi');
    const leftShadow = document.querySelector('.scroll-shadow--left');
    const rightShadow = document.querySelector('.scroll-shadow--right');

    if (!container || !leftShadow || !rightShadow) return;

    const updateShadows = () => {
      const scrollLeft = container.scrollLeft;
      const scrollWidth = container.scrollWidth;
      const clientWidth = container.clientWidth;

      // 5px buffer prevents visual flickering at the extreme edges of the scroll container
      const isAtStart = scrollLeft <= 5;
      const hasOverflow = scrollWidth > clientWidth;
      const isAtEnd = scrollLeft + clientWidth >= scrollWidth - 5;

      if (!hasOverflow) {
        leftShadow.classList.remove('is-visible');
        rightShadow.classList.remove('is-visible');
        return;
      }

      if (isAtStart) leftShadow.classList.remove('is-visible');
      else leftShadow.classList.add('is-visible');

      if (isAtEnd) rightShadow.classList.remove('is-visible');
      else rightShadow.classList.add('is-visible');
    };

    container.addEventListener('scroll', updateShadows);
    window.addEventListener('resize', updateShadows);
    updateShadows();
  };

  const enableDragScroll = () => {
    const slider = document.querySelector('.mini-compare-grid');
    if (!slider || slider.classList.contains('mini-compare-grid--dual')) return;

    let isDown = false;
    let isDragging = false;
    let startX;
    let scrollLeft;

    // Tracks the timeout ID to prevent state race conditions during rapid clicks
    let dragTimeout;

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      isDragging = false;

      // Clear pending timeouts to ensure a clean state for the new interaction
      clearTimeout(dragTimeout);
      slider.classList.remove('is-dragging');

      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    const stopDragging = () => {
      isDown = false;

      if (isDragging) {
        clearTimeout(dragTimeout);

        // 50ms delay keeps pointer-events disabled just long enough to block child click events
        dragTimeout = setTimeout(() => {
          slider.classList.remove('is-dragging');
          isDragging = false;
        }, 50);
      } else {
        slider.classList.remove('is-dragging');
      }
    };

    slider.addEventListener('mouseleave', stopDragging);
    slider.addEventListener('mouseup', stopDragging);

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();

      const x = e.pageX - slider.offsetLeft;
      const rawDelta = x - startX;

      // 5px physical threshold distinguishes an intentional drag from a sloppy click
      if (Math.abs(rawDelta) > 5) {
        isDragging = true;
        slider.classList.add('is-dragging');
      }

      if (isDragging) {
        // 2x multiplier accelerates the scroll speed for a more responsive UX
        const walk = rawDelta * 2;
        slider.scrollLeft = scrollLeft - walk;
      }
    });
  };

  const enableKeyboardNav = () => {
    const slider = document.querySelector('.mini-compare-grid');
    if (!slider) return;

    slider.addEventListener('keydown', (e) => {
      // Prevent scrolling the entire page if the user is just tabbing through the grid
      if (document.activeElement === slider) {
        // Fixed pixel distance to jump per arrow key press
        const scrollAmount = 300;

        if (e.key === 'ArrowRight') {
          e.preventDefault();
          slider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          slider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        }
      }
    });
  };

  handleScrollShadows();
  enableDragScroll();
  enableKeyboardNav();
});
